import { Mutations } from 'gql';
import withMutation from 'gql/withMutation';

import GroupId from 'model/GroupId';
import LocationId from 'model/LocationId';
import ServiceConnectionId from 'model/ServiceConnectionId';
import { useMutation } from 'react-apollo';

export default withMutation({
  name: 'DELETE_PROJECT_ITEMS',
  mutation: Mutations.DELETE_PROJECT_ITEMS,
  mutateProp: 'deleteProjectItems',
  getMutationArgs(projectId, phaseId, itemIds) {
    const locationIds = itemIds.filter((i) => i instanceof LocationId);
    const locationGroupIds = itemIds.filter((i) => i instanceof GroupId);
    const serviceConnectionIds = itemIds.filter((i) => i instanceof ServiceConnectionId);
    return {
      variables: {
        projectId,
        phaseId,
        locationIds,
        locationGroupIds,
        serviceConnectionIds,
      },
    };
  },
});

export const useDeleteProjectItems = () => {
  const [doDeleteProjectItems] = useMutation(Mutations.DELETE_PROJECT_ITEMS);

  const deleteProjectItems = async (projectId, phaseId, itemIds) => {
    const locationIds = itemIds.filter((i) => i instanceof LocationId);
    const locationGroupIds = itemIds.filter((i) => i instanceof GroupId);
    const serviceConnectionIds = itemIds.filter((i) => i instanceof ServiceConnectionId);

    await doDeleteProjectItems({
      variables: {
        projectId,
        phaseId,
        locationIds,
        locationGroupIds,
        serviceConnectionIds,
      },
    });
  };
  return { deleteProjectItems };
};
